// Libs
import clsx from "clsx";
import { alterElement } from "src/design-system/core/utils";
import { Tabs, type TabsProps } from "src/design-system/molecules/navigation/Tabs";

// Components

export type PillTabsProps<T extends number | string = number | string> = TabsProps<T>;

export function PillTabs<T extends number | string = number | string>({
    children,
    className: classNameProp,
    ...props
}: PillTabsProps<T>): JSX.Element {
    const className = clsx("ds-c-pill-tabs", classNameProp);

    return (
        <Tabs className={className} {...props}>
            {alterElement(children, { labelClassName: "ds-u-typography--body" })}
        </Tabs>
    );
}
